import { render, staticRenderFns } from "./ComposedLogo.vue?vue&type=template&id=7e0b8e2e&scoped=true&"
import script from "./ComposedLogo.vue?vue&type=script&lang=js&"
export * from "./ComposedLogo.vue?vue&type=script&lang=js&"
import style0 from "./ComposedLogo.vue?vue&type=style&index=0&id=7e0b8e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0b8e2e",
  null
  
)

export default component.exports